import*as e from"react";export default typeof window!="undefined"&&typeof window.document!="undefined"&&typeof window.document.createElement!="undefined"?e.useLayoutEffect:e.useEffect;
